<template>
  <b-card title="محتوای متنی بلند">
    <b-card-text>
      <span>در این قسمت می توانید محتوای متنی بلند خود را وارد کنید </span>
    </b-card-text>


    <b-form-group
        label="نام محتوا "
        label-for="v-content-title"
    >
      <b-form-input
          id="v-content-title"
          placeholder="این نام داخل اپلیکیشن نمایش داده نمی شود و صرفا جهت مدیریت داخل پنل قابل نمایش است"
          v-model="data.name"
      />
    </b-form-group>
    <b-form-group
        label="نام محتوا "
        label-for="v-content-title"
    >
      <ckeditor :editor="editor" v-model="data.content" :config="editorConfig"></ckeditor>
    </b-form-group>


    <b-form-group>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="success"
          class="mr-1 mt-1"
          @click="SaveContent"
      >
        ثبت
      </b-button>
    </b-form-group>

  </b-card>
</template>

<script>
import {BFormTextarea, BCardText, BCard, BFormGroup, BFormInput, BButton} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import CKEditor from '@ckeditor/ckeditor5-vue2'

import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading';
import AlignmentPlugin from '@ckeditor/ckeditor5-alignment/src/alignment';
import TypingPlugin from '@ckeditor/ckeditor5-typing/src/typing';
import ImagePlugin from "@ckeditor/ckeditor5-image/src/image";
import blockQuote from "@ckeditor/ckeditor5-block-quote/src/blockquote";
import indent from "@ckeditor/ckeditor5-indent/src/indent";
import TablePlugin from "@ckeditor/ckeditor5-table/src/table";
import FontPlugin from "@ckeditor/ckeditor5-font/src/font";
import ListPlugin from "@ckeditor/ckeditor5-list/src/list";
import LineHeight from '../../../libs/ckeditor5-line-height-plugin/src/lineheight';
export default {
  name: "longTextFormComponent",
  components: {
    BCard,
    BButton,
    BFormInput,
    BFormGroup,
    BFormTextarea,
    BCardText,
    ckeditor: CKEditor.component
  },
  data() {
    return {
      data: {
        name: '',
        content: ''
      },
      editor: ClassicEditor,
      editorData: '<p>محتوای شما در این قسمت قرار میگیرد</p>',
      editorConfig: {
        language: 'fa',
        // The configuration of the editor.
        plugins: [
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ParagraphPlugin,
          HeadingPlugin,
            LineHeight,
          AlignmentPlugin,
          TypingPlugin,
          ImagePlugin,
          blockQuote,
          indent,
          TablePlugin,
          FontPlugin,
          ListPlugin
        ],
        fontFamily:{
          options : [
            'default',
            'Dana' ,
            'IranYekan' ,
            'Iransans' ,
            'Arial, Helvetica, sans-serif',
            'Courier New, Courier, monospace',
            'Georgia, serif',
            'Lucida Sans Unicode, Lucida Grande, sans-serif',
            'Tahoma, Geneva, sans-serif',
            'Times New Roman, Times, serif',
            'Trebuchet MS, Helvetica, sans-serif',
            'Verdana, Geneva, sans-serif' ,
          ]
        },
        lineHeight: { // specify your otions in the lineHeight config object. Default values are [ 0, 0.5, 1, 1.5, 2 ]
          options: [ 0.5, 1, 1.5, 2, 2.5 ]
        },
        fontSize: {
          options: [
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24
          ],
          supportAllValues: true
        },
        toolbar: {
          items: [
            'heading', '|',
            'alignment', '|',
            'bold', 'italic', 'strikethrough', 'underline', 'subscript', 'superscript', '|',
            'link', '|',
            'bulletedList', 'numberedList', 'todoList',
            '-', // break point
            'fontfamily', 'fontsize', 'fontColor', 'fontBackgroundColor', '|',
            'code', 'codeBlock', '|',
            'insertTable', '|',
            'outdent', 'indent', '|',
            'uploadImage', 'blockQuote', '|',
            'undo', 'redo'
          ],
          shouldNotGroupWhenFull: false
        }
      }
    }
  },
  methods: {
    SaveContent(event) {
      this.$emit('longTextSubmit', this.data)
    }
  }
  ,
  directives: {
    Ripple,
  },

}
</script>

<style scoped>
.ck-editor__editable {
  height: 400px !important;
}
</style>
